'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Spinner = require('../Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormLayout = function FormLayout(_ref) {
  var onSubmit = _ref.onSubmit,
      fieldComponents = _ref.fieldComponents,
      buttonClassName = _ref.buttonClassName,
      submitText = _ref.submitText,
      children = _ref.children,
      submitting = _ref.submitting,
      disabled = _ref.disabled,
      formClassName = _ref.formClassName;
  return _react2.default.createElement(
    'form',
    { onSubmit: onSubmit, className: 'form ' + formClassName },
    _react2.default.createElement(
      'div',
      { className: 'white-box item-box' },
      _react2.default.createElement(
        'div',
        { className: 'inner' },
        _react2.default.createElement(
          'div',
          { className: 'row form-row' },
          fieldComponents
        ),
        children,
        _react2.default.createElement(
          'button',
          { disabled: disabled, className: buttonClassName, type: 'submit' },
          submitText
        ),
        _react2.default.createElement(_Spinner2.default, { loading: submitting })
      )
    )
  );
};

FormLayout.defaultProps = {
  buttonClassName: 'btn',
  submitText: 'Submit',
  submitting: false,
  disabled: false,
  children: '',
  formClassName: ''
};

FormLayout.propTypes = {
  onSubmit: _propTypes2.default.func.isRequired,
  fieldComponents: _propTypes2.default.arrayOf(_propTypes2.default.node).isRequired,
  buttonClassName: _propTypes2.default.string,
  submitText: _propTypes2.default.string,
  submitting: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  formClassName: _propTypes2.default.string
};

exports.default = FormLayout;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/components/form/FormLayout.js
// module id = 1111
// module chunks = 0